import {ActionType, CleanResponse} from "../model";

export const updateDocumentsRequest: any = (payload:any) => async (dispatch, store, api) => {
    try {
        let resp = await api.post('service/documents-requests', payload, {});
        return dispatch({type: ActionType.ALERT, payload: {message: "Request sent successfully. ", statusCode: 200}});
    } catch (err) {
        return dispatch({type: ActionType.ALERT, payload: err});
    }
};